import VehicleBlockShell from "./VehicleBlockShell";

export default VehicleBlockShell;
export { VehicleBlockShell };
